import React, { useEffect, useState } from "react";
import "./style.scss";
import * as _ from "lodash";
import { useLocation, useSearchParams } from "react-router-dom";
import Modal from "react-bootstrap/Modal";
import { MdImageNotSupported, MdKeyboardArrowDown } from "react-icons/md";
import Logo from "../../../assets/images/asthi-logo.svg";
import DataNotFound from "../../../components/shared/DataNotFound/DataNotFound";
import ImageGallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";
import { useTranslation } from "react-i18next";
import i18n from "../../../i18n";
import {
  FaHandHoldingHeart,
  FaNotesMedical,
  FaPersonWalking,
  FaPhoneVolume,
  FaRegAddressCard,
} from "react-icons/fa6";
import { useLastVisitMutation } from "../../../api/lastVisit";

const LastVisitInfo = () => {
  const location = useLocation();

  const { t } = useTranslation();
  const [selectedImage, setSelectedImage] = useState(null);
  const [allImageStor, setAllImageStor] = useState([]);
  const [allInstruction, setAllInstruction] = useState([]);
  const [getLastVisitResData, setLastVisitResData] = useState([]);
  const [selectedLanguage, setSelectedLanguage] = useState(
    localStorage.getItem("selectedLanguage") || "english",
  );
  const [isInstructionOpen, setIsInstructionOpen] = useState(false);

  function base64ToString(base64) {
    // Decode the Base64 string into a decoded string
    const decodedString = atob(base64);

    // Return the decoded string
    return decodeURIComponent?.(escape(decodedString));
  }

  const [searchParams] = useSearchParams();
  const idNumber = searchParams?.get("idNumber"); // "testCode"
  const mobileNumber = searchParams?.get("mobileNumber"); // "testCode"

  const [triggerLastVisit, { data: getLastVisitRes }] =
    useLastVisitMutation();

  useEffect(() => {
    if (idNumber || mobileNumber) {
      triggerLastVisit({
        idNumber: idNumber ? base64ToString(idNumber) : "",
        mobileNumber: mobileNumber ? base64ToString(mobileNumber) : "",
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [idNumber, mobileNumber]);

  useEffect(() => {
    if (getLastVisitRes?.status !== 200) return;
    setLastVisitResData(getLastVisitRes?.data);
  }, [getLastVisitRes]);

  const lastVisitInfo = location?.state?.data || getLastVisitResData;
  const instruction =
    lastVisitInfo?.instruction || getLastVisitResData?.instruction;
  const exercise = lastVisitInfo?.exercise || getLastVisitResData?.exercise;

  useEffect(() => {
    if (instruction?.length > 0) {
      const instructionList = instruction.reduce((acc, item) => {
        if (item?.instructions) {
          acc.push(...item.instructions);
        }
        return acc;
      }, []);
      setAllInstruction(instructionList);
    } else {
      setAllInstruction([]);
    }

    if (exercise?.length > 0) {
      const imageList = exercise.reduce((acc, item) => {
        if (item?.images) {
          acc.push(...item.images);
        }
        return acc;
      }, []);
      setAllImageStor(imageList);
    } else {
      setAllImageStor([]);
    }
  }, [exercise, instruction]);

  useEffect(() => {
    if (selectedLanguage) {
      i18n.changeLanguage(selectedLanguage);
    }
  }, [selectedLanguage]);

  const openModal = (imageIndex) => {
    setSelectedImage(imageIndex);
  };

  const closeModal = () => {
    setSelectedImage(null);
  };

  const selectLanguage = [
    { value: "english", label: "English" },
    { value: "gujarati", label: "ગુજરાતી" },
    { value: "hindi", label: "हिन्दी" },
  ];

  const handleSelectLanguage = (language) => {
    setSelectedLanguage(language);
    localStorage.setItem("selectedLanguage", language);
    i18n.changeLanguage(language);
  };

  const galleryItems = allImageStor.map((image) => ({
    original: image.image,
    thumbnail: image.image,
  }));

  const getInstructionText = (item) => {
    const languageInstruction = item?.instructionLanguage?.find(
      (lang) =>
        lang?.languageId?.name?.toLowerCase() ===
        selectedLanguage.toLowerCase(),
    );

    return languageInstruction ? languageInstruction.text : item?.text;
  };

  const fullName =
    `${lastVisitInfo?.firstName || ""} ${lastVisitInfo?.lastName || ""}`.trim();
  const summaryCards = [
    // {
    //   key: "instruction",
    //   icon: <FaNotesMedical />,
    //   label: t("instruction"),
    //   value: `${allInstruction.length || 0} ${t("instruction")}`,
    // },
    {
      key: "id",
      icon: <FaRegAddressCard />,
      label: t("idNumber"),
      value: lastVisitInfo?.idNumber || "-",
    },
    {
      key: "mobile",
      icon: <FaPhoneVolume />,
      label: t("mobile"),
      value: lastVisitInfo?.mobileNumber || "-",
    },
  ];

  return (
    <div className=" container-fluid p-0" id="lastVisitInfo">
      <div className="logo-img text-center w-100 bg-[#e2f4fe]">
        <img src={Logo} alt="Logo" />
      </div>

      {!_.isEmpty(lastVisitInfo) ? (
        <div className="lastVisit-shell">
          <div
            className="visit-hero"
           
          >
            <div className="visit-hero__copy">
              {/* <span className="visit-hero__eyebrow">{t("hello")}</span> */}
              <div className="panel__header h5">
              <h5> {fullName}</h5></div>
              <p className="">{t("lastVisitIntro")}</p>
            </div>
          </div>

          <div className="info-row">
            <div className="summary-grid summary-grid--left">
              {summaryCards.slice(0, 1).map((item) => (
                <div key={item.key} className=".card-grid">
                  {/* <div className="summary-card__icon">{item.icon}</div> */}
                  {/* <div className="summary-card__content"> */}
                  <span>{item.label} : </span>
                  <strong>{item.value}</strong>
                  {/* </div> */}
                </div>
              ))}
            </div>

            <div className="language-row" aria-label="Language selection">
              {selectLanguage.map((option) => (
                <button
                  key={option.value}
                  type="button"
                  className={`language-chip ${
                    selectedLanguage === option.value ? "is-active" : ""
                  }`}
                  onClick={() => handleSelectLanguage(option.value)}
                >
                  {option.label}
                </button>
              ))}
            </div>

            <div className="summary-grid summary-grid--right">
              {summaryCards.slice(1).map((item) => (
                <div key={item.key} className=".card-grid">
                  {/* <div className="summary-card__icon">{item.icon}</div> */}
                  {/* <div className="summary-card__content"> */}
                  <span>{item.label} : </span>
                  <strong>{item.value}</strong>
                  {/* </div> */}
                </div>
              ))}
            </div>
          </div>

          <div className="content-grid">
            <section className="panel panel--instructions">
              <div
                className="panel__header panel__header--toggle"
                onClick={() => setIsInstructionOpen((prev) => !prev)}
              >
                <div className="panel__icon">
                  <FaNotesMedical />
                </div>
                <h5>{t("instruction")}</h5>
                <MdKeyboardArrowDown
                  className={`panel__toggle-icon ${isInstructionOpen ? "is-open" : ""}`}
                />
              </div>

              <div
                className={`panel__body instruction-info ${
                  isInstructionOpen ? "is-open" : ""
                }`}
              >
                <ul className="instruction-list">
                  {allInstruction.map((item) => (
                    <li key={item?.id || item?.text}>
                      {getInstructionText(item)}
                    </li>
                  ))}
                </ul>
              </div>
            </section>

            {allImageStor.length > 0 && (
              <section className="panel panel--exercise">
                <div className="panel__header">
                  <div className="panel__icon panel__icon--green">
                    <FaPersonWalking />
                  </div>
                  <h5>{t("exercise")}</h5>
                </div>

                <div className="panel__body exercise-info">
                  <div className="exercise-grid">
                    {allImageStor.map((image, index) => (
                      <button
                        type="button"
                        className="exercise-thumb"
                        key={image?.id || index}
                        onClick={() => openModal(index)}
                      >
                        {image?.image ? (
                          <img src={image.image} alt="exercise" />
                        ) : (
                          <MdImageNotSupported className="image-not-supported" />
                        )}
                      </button>
                    ))}
                  </div>
                </div>
              </section>
            )}
          </div>

          <div className="wellness-card">
            <div className="wellness-card__icon">
              <FaHandHoldingHeart />
            </div>
            <div className="wellness-card__content">
              <strong>{t("careNote")}</strong>
              <p>{t("careNoteDetail")}</p>
            </div>
          </div>

          <footer className="page-footer">
            <span>© 2026 Asthi Care. All rights reserved.</span>
            <span className="page-footer__powered">
              <span> Powered by KM Soft </span>
                <img
                src={`${process.env.PUBLIC_URL}/kmsoftlogo.png`}
                alt="KM Soft"
                className="page-footer__powered-logo"
              />
              
            </span>
          </footer>
        </div>
      ) : (
        <DataNotFound />
      )}

      <Modal show={selectedImage !== null} onHide={closeModal} centered>
        <Modal.Body>
          <div className="position-relative">
            <ImageGallery
              items={galleryItems}
              startIndex={selectedImage ?? 0}
              showFullscreenButton={false}
              showPlayButton={false}
              showThumbnails={false}
              showNav={false}
            />
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default LastVisitInfo;